import { logo } from "@/assets/Index";
import React from "react";

const NotificationCard = ({ image, title, date, description }) => {
  return (
    <div className="w-full flex flex-col gap-1 md:gap-2  p-2 md:p-4 bg-background rounded-xl">
      <div className="flex gap-2 justify-start">
        {!image ? (
          <img
            src={logo || ""}
            alt={""}
            className="w-8 h-8 rounded-full object-cover bg-background"
          />
        ) : (
          <img
            src={image || ""}
            alt={""}
            className="w-8 h-8 rounded-full object-cover bg-gradient-to-r from-blue-500 to-transparent"
          />
        )}
        <div className="flex flex-col gap-1">
          <p className="text-body1 md:text-subtitle2 font-nunito font-semibold text-secondary">
            {title}
          </p>
          <span className="text-caption md:text-body2   text-secondary/70">
            {date}
          </span>
        </div>
      </div>
      <div className="pl-10 ">
        <p className="text-body2 md:text-body1 text-secondary">{description}</p>
      </div>
    </div>
  );
};

export default NotificationCard;
